import { types, actions } from './requests'
export const WORKDAY_TYPES = {
    ...types('WORKDAY'),
}
export const WORKDAY_ACTIONS = {
    ...actions('WORKDAY'),
}
